import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [
  {
    path: '/',
    redirect: '/main'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('../views/SignupView.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/main',
    name: 'main',
    component: () => import('../views/MainView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/SettingsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/articles',
    name: 'articles-list',
    component: () => import('../views/ArticlesListView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/research-posts',
    name: 'research-posts-list',
    component: () => import('../views/ResearchPostsListView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/content-ideas',
    name: 'content-ideas',
    component: () => import('../views/ContentIdeasView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/article/new',
    name: 'article-new',
    component: () => import('../views/ArticleConfigView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/article/:id/config',
    name: 'article-config',
    component: () => import('../views/ArticleConfigView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/article/:id/planning',
    name: 'article-planning',
    component: () => import('../views/ArticlePlanningView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/article/:id/plan',
    name: 'article-plan',
    component: () => import('../views/ArticlePlanView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/article/:id/workshop',
    name: 'article-workshop',
    component: () => import('../views/ArticleWorkshopView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/article/:id/publish',
    name: 'article-publish',
    component: () => import('../views/ArticlePublishingView.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard
// eslint-disable-next-line @typescript-eslint/no-explicit-any
router.beforeEach(async (to: any, from: any, next: any) => {
  // Try to fetch user if not already loaded
  if (!store.getters.isAuthenticated) {
    await store.dispatch('fetchUser')
  }

  const isAuthenticated = store.getters.isAuthenticated

  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (to.meta.requiresGuest && isAuthenticated) {
    next('/main')
  } else {
    // Check onboarding for authenticated routes
    if (isAuthenticated && to.meta.requiresAuth) {
      store.dispatch('checkOnboarding')
    }
    next()
  }
})

export default router
